import { render } from "./ProfissionalSaude.vue?vue&type=template&id=792c8f20&scoped=true"
import script from "./ProfissionalSaude.vue?vue&type=script&lang=js"
export * from "./ProfissionalSaude.vue?vue&type=script&lang=js"

import "./ProfissionalSaude.vue?vue&type=style&index=0&id=792c8f20&scoped=true&lang=css"

import exportComponent from "J:\\Centrion\\projetos\\apracam_ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-792c8f20"]])

export default __exports__